import React, { CSSProperties, FC, memo } from "react"
import { GetCompanyQuery, NewBookingInput, OptionalInputFieldsInput } from "../../../../../generated/graphql"
import FormItem from "antd/lib/form/FormItem"
import { Button, Checkbox } from "antd"
import css from "../../StepSummary2.module.css"
import type { NewBookingInputKeys } from "../bookingInputTypes"
import classnames from "classnames"
import { LinkOutlined } from "@ant-design/icons"
import { blue } from "@ant-design/colors"
import { URL_DATENSCHUTZ } from "../../../../../models/url"
import { isEmbeddedForInternalRoutes } from "../../../../../helpers/embedMode"

type PrivacyStatementInputProps = {
    field: OptionalInputFieldsInput
    bookingData?: NewBookingInput
    updateBookingData: (key: NewBookingInputKeys, value: any) => void
    style?: CSSProperties
    showAlert?: boolean
    companySettings?: GetCompanyQuery["companyPublic"]
}

const PrivacyStatementInput: FC<PrivacyStatementInputProps> = ({ field, bookingData, updateBookingData, style, showAlert, companySettings }) => {
    const updatePrivacyStatementConfirmation = (checked: boolean) => {
        updateBookingData("privacyStatementConfirmed", checked)
    }

    const PrivacyStatementLink = ({ label, icon }: { label?: string; icon?: boolean }) => {
        // Prüfe ob externe URL vorhanden ist
        const externalUrl = companySettings?.privacyStatement
        // Prüfe ob App in iFrame läuft (für interne Route)
        const isInIframe = isEmbeddedForInternalRoutes()
        
        // Wenn keine externe URL vorhanden ist und App in iFrame läuft, verwende interne Route
        if (!externalUrl && isInIframe) {
            return (
                <Button style={{ paddingLeft: 0, fontWeight: 500 }} type='link' size='small'>
                    <a href={`#${URL_DATENSCHUTZ}`}>
                        {label ?? label}
                        {icon && <LinkOutlined style={{ color: blue[5], marginLeft: 3, fontSize: "small" }} />}
                    </a>
                </Button>
            )
        }
        
        // Externe URL hat Priorität
        if (externalUrl) {
            return (
                <Button style={{ paddingLeft: 0, fontWeight: 500 }} type='link' size='small'>
                    <a href={externalUrl} target='_blank' rel='noopener noreferrer'>
                        {label ?? label}
                        {icon && <LinkOutlined style={{ color: blue[5], marginLeft: 3, fontSize: "small" }} />}
                    </a>
                </Button>
            )
        }
        
        return null
    }

    const alertAndNotChecked = showAlert && !Boolean(bookingData?.privacyStatementConfirmed)

    return (
        <>
            <FormItem style={style} key={field.name}>
                <Checkbox
                    data-testid='privacy-statement-checkbox'
                    className={alertAndNotChecked ? classnames(css.inputLabel, css.alert) : css.inputLabel}
                    onChange={(e) => updatePrivacyStatementConfirmation(e.target.checked)}
                    checked={Boolean(bookingData?.privacyStatementConfirmed)}
                >
                    <PrivacyStatementLink label={field.label ?? undefined} />
                </Checkbox>
                <div className={css.inputDescription}>
                    {field.description}
                    <PrivacyStatementLink icon />
                </div>
            </FormItem>
        </>
    )
}

export default memo(PrivacyStatementInput)
